<template>
    <div class="c-login">
        <h1>{{$t('login.title')}}</h1>
        <div class="form">
            <form autocomplete="off">
                <div class="form--row anim">
                    <div class="form--row--label">{{$t('generic.email')}}</div>
                    <input type="email" ref="email" class="inputfield" @change="emailUpdated" :class="{error : emailError}" v-model="email" autocomplete="off"/>
                </div>
                <div class="form--row anim">
                    <div class="form--row--label">{{$t('generic.password')}}</div>
                    <input type="password" class="inputfield" :class="{error : passwordError}" v-model="password" autocomplete="off"/>
                </div>
                <div class="form--row select" v-if="showShopSelect">
                    <div class="form--row--label">Selecteer winkel</div>
                    <select v-model="shopId">
                        <option :value="shop.id" v-for="shop in shops" :key="shop.id">{{ shop.name }}</option>
                    </select>
                </div>
                <div class="form--row anim">
                    <div class="form--row--label"></div>
                    <button class="btn-basic blue" @click.prevent="login" :disabled="loading">{{$t('login.btn')}}</button>
                </div>
                <div class="form--row" v-if="loginError">
                    <div class="form--row--label"></div>
                    <div class="form--error">{{$t('login.error')}}</div>
                </div>
                <div class="form--row" v-if="shopError">
                    <div class="form--row--label"></div>
                    <div class="form--error">{{$t('login.shop_error')}}</div>
                </div>
                <div class="form--row" v-if="salesError">
                    <div class="form--row--label"></div>
                    <div class="form--error">{{$t('login.sales_error')}}</div>
                </div>
                <div class="form--row anim forgot">
                    <a href="#" class="" @click.prevent="clickResetPass">{{$t('login.forgot_pass')}}</a>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import {isValidEmail, isMobile} from "@/utils/utils.js";
import LoginMixin from "@/mixins/LoginMixin";
import {apiStore} from "@/stores/api.js";

export default {
    name : "Login",

    mixins : [LoginMixin],

    data() {
        return {
            email: "",
            password: "",
            emailError : false,
            passwordError : false,
            loginError : false,
            shopError : false,
            salesError : false,
            loading : false,
            deferredPrompt : null,
            mobile : false,
            showShopSelect : false,
            shops : [],
            shopId : 0
        };
    },

    created() {
        this.mobile = isMobile();

        if (this.loggedInUser) {
            this.gotoAppointments();
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.email = this.$refs.email.value;
        });
    },

    methods: {
        async login() {
            this.shopError = this.loginError = false;
            this.emailError = this.passwordError = false;

            if (!isValidEmail(this.email)) {
                this.emailError = true;
            }

            if (this.password.trim() === "") {
                this.passwordError = true;
            }

            if (!this.emailError && !this.passwordError) {
                this.loading = true;

                const response = await apiStore().loginUser(this.email, this.password);
                this.loading = false;

                if (response === null) {
                    this.loginError = true;

                } else if (response.role === "superadmin") {
                    this.$router.push({name : "shop-admin"});

                } else if (response.role === "service") {
                    // set shop id from select
                    apiStore().setUserShop(this.shops.find(x => x.id === this.shopId));
                    this.gotoAppointments();

                } else if (response.shop === null) {
                    this.shopError = true;

                } else {
                    this.gotoAppointments();
                }
            }
        },

        clickResetPass() {
            this.$router.push({name : "reset-password"});
        },

        async gotoAppointments() {
            const sales = await apiStore().getSalesForShop();

            if (sales.length > 0) {
                this.salesError = false;

                apiStore().setLoggedInSales(sales[0]);

                this.$router.replace({name : "appointment-list"});
            } else {
                this.salesError = true;
            }
        },

        async emailUpdated() {
            const response = await apiStore().checkIfServiceUser(this.email);
            this.showShopSelect = response.service_user;
            if (this.showShopSelect) {
                const response = await apiStore().getShops();
                this.shops = response.sort((a, b) => a.name < b.name ? -1 : 1);
                if (this.shops.length > 0) {
                    this.shopId = this.shops[0].id;
                }
            }
        }

    }
};
</script>

<style lang="scss" scoped>
.c-login {
    text-align: center;

    h1 {
        margin-top : 10vh;
    }

    .form {
        margin : 6vh auto;
        width : 50vw;

        .inputfield {
            width : 65%;
        }

        &--row {
            display: flex;
            &.anim {
                @for $i from 1 through 5 {
                    &:nth-child(#{$i}) {
                        @include slideIntroAnimation(basicSlideIntro, 750ms, #{350ms + $i * 350ms});
                    }
                }
            }

            &.select {
                margin-top: .5rem;
                padding-bottom: 1.5rem;

                select {
                    font-size: 1rem;
                    padding: 0 0.5rem;
                    box-shadow: 0px 4px 6px 1px rgba(0, 0, 0, 0.15);
                    border-radius: 0.25rem;
                }
            }

            &.forgot {
                margin-left : 37.5%;
                margin-top : 1rem;
            }

            &--label {
                padding-top: 1rem;
                font-size: 1.5em;
                width: 30%;
                text-align: right;
                margin-right: 5%;

            }
        }

        &--error {
            font-size: 1.25em;
            margin-top : 2rem;
            margin-left: 5rem;
            color : $color-red;
            text-align: left;
            width: 100%;
        }
    }

    &--btn-install {
        position: fixed;
        bottom : 1rem;
        left : 1rem;

        @include slideIntroAnimation(keyboardIntro, 750ms, 1750ms);
    }
}
</style>